(function () {
  var globalsBound = false;

  function setupHeader() {
    var header = document.querySelector('.oddit-header');
    // Bail if there is no header, or this header element was already wired.
    // On hot-reload / theme-editor re-render the section HTML is replaced with
    // a fresh element (no flag), so this re-runs and re-binds to the new nodes.
    if (!header || header.__odditHeaderInit) return;
    header.__odditHeaderInit = true;

    var overlay = header.querySelector('[data-header-overlay]');
    var megaMenus = header.querySelectorAll('[data-mega-menu-panel]');
    var megaTriggers = header.querySelectorAll('[data-mega-menu-trigger]');
    var drawer = header.querySelector('[data-mobile-drawer]');
    var menuToggle = header.querySelector('[data-mobile-menu-toggle]');

    var megaCloseTimer = null;
    var activeTrigger = null;

    function isHoverPointer(e) {
      return e.pointerType === 'mouse' || e.pointerType === 'pen';
    }

    function openMegaMenu(label) {
      if (!megaMenus.length) return;
      var matched = false;
      for (var i = 0; i < megaMenus.length; i++) {
        var panel = megaMenus[i];
        if (panel.getAttribute('data-mega-menu-label') === label) {
          panel.classList.add('is-open');
          panel.setAttribute('aria-hidden', 'false');
          matched = true;
        } else {
          panel.classList.remove('is-open');
          panel.setAttribute('aria-hidden', 'true');
        }
      }
      if (matched && overlay) {
        positionOverlayBelowHeader();
        overlay.classList.add('is-visible');
      }
    }

    function closeMegaMenu() {
      if (!megaMenus.length) return;
      for (var i = 0; i < megaMenus.length; i++) {
        megaMenus[i].classList.remove('is-open');
        megaMenus[i].setAttribute('aria-hidden', 'true');
      }
      var drawerOpen = drawer && drawer.classList.contains('is-open');
      if (overlay && !drawerOpen) {
        overlay.classList.remove('is-visible');
        overlay.style.top = '';
      }
      for (var j = 0; j < megaTriggers.length; j++) {
        megaTriggers[j].setAttribute('aria-expanded', 'false');
      }
      activeTrigger = null;
    }

    function openMegaMenuFor(trigger) {
      clearTimeout(megaCloseTimer);
      var label = trigger.getAttribute('data-mega-menu-label');
      for (var i = 0; i < megaTriggers.length; i++) {
        megaTriggers[i].setAttribute('aria-expanded', 'false');
      }
      trigger.setAttribute('aria-expanded', 'true');
      activeTrigger = trigger;
      openMegaMenu(label);
    }

    function scheduleCloseMegaMenu() {
      clearTimeout(megaCloseTimer);
      megaCloseTimer = window.setTimeout(closeMegaMenu, 180);
    }

    // Bind mega menu triggers
    for (var t = 0; t < megaTriggers.length; t++) {
      (function (trigger) {
        var wrapper = trigger.closest('.oddit-header__nav-item') || trigger.parentElement;

        trigger.addEventListener('click', function (e) {
          e.preventDefault();
          var isOpen = trigger.getAttribute('aria-expanded') === 'true';
          if (isOpen) {
            closeMegaMenu();
          } else {
            openMegaMenuFor(trigger);
          }
        });

        if (wrapper) {
          wrapper.addEventListener('pointerenter', function (e) {
            if (!isHoverPointer(e)) return;
            openMegaMenuFor(trigger);
          });
          wrapper.addEventListener('pointerleave', function (e) {
            if (!isHoverPointer(e)) return;
            scheduleCloseMegaMenu();
          });
        }
      })(megaTriggers[t]);
    }

    // Keep mega menu open while pointer is inside any panel
    for (var m = 0; m < megaMenus.length; m++) {
      megaMenus[m].addEventListener('pointerenter', function (e) {
        if (!isHoverPointer(e)) return;
        clearTimeout(megaCloseTimer);
      });
      megaMenus[m].addEventListener('pointerleave', function (e) {
        if (!isHoverPointer(e)) return;
        scheduleCloseMegaMenu();
      });
    }

    // Anchor the mega-menu overlay to the bottom of the header group so the
    // scrim dims the page content but leaves the header + open mega menu bright.
    function positionOverlayBelowHeader() {
      if (!overlay) return;
      var headerBottom = Math.max(0, Math.round(header.getBoundingClientRect().bottom));
      overlay.style.top = headerBottom + 'px';
    }

    // Mobile drawer
    function positionDrawerBelowHeader() {
      if (!drawer) return;
      // Open the drawer below the visible header bars rather than covering them.
      var headerBottom = Math.max(0, Math.round(header.getBoundingClientRect().bottom));
      drawer.style.top = headerBottom + 'px';
    }

    function openDrawer() {
      if (!drawer) return;
      positionDrawerBelowHeader();
      drawer.classList.add('is-open');
      drawer.setAttribute('aria-hidden', 'false');
      // Drawer scrim covers the full viewport (reset any mega-menu offset).
      if (overlay) {
        overlay.style.top = '';
        overlay.classList.add('is-visible');
      }
      if (menuToggle) menuToggle.setAttribute('aria-expanded', 'true');
      document.body.classList.add('oddit-header-drawer-open');
    }

    function closeDrawer() {
      if (!drawer) return;
      drawer.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
      if (overlay) overlay.classList.remove('is-visible');
      if (menuToggle) menuToggle.setAttribute('aria-expanded', 'false');
      document.body.classList.remove('oddit-header-drawer-open');
      closeAllDrawerPanels();
    }

    if (menuToggle && drawer) {
      menuToggle.addEventListener('click', function () {
        if (drawer.classList.contains('is-open')) {
          closeDrawer();
        } else {
          openDrawer();
        }
      });
    }

    // Mobile search slide-down panel
    var searchToggle = header.querySelector('[data-mobile-search-toggle]');
    var searchPanel = header.querySelector('[data-mobile-search-panel]');

    function positionSearchPanelBelowHeader() {
      if (!searchPanel) return;
      var headerBottom = Math.max(0, Math.round(header.getBoundingClientRect().bottom));
      searchPanel.style.top = headerBottom + 'px';
    }

    function openSearchPanel() {
      if (!searchPanel) return;
      positionSearchPanelBelowHeader();
      searchPanel.classList.add('is-open');
      searchPanel.setAttribute('aria-hidden', 'false');
      // Search scrim covers the full viewport (reset any mega-menu offset).
      if (overlay) {
        overlay.style.top = '';
        overlay.classList.add('is-visible');
      }
      if (searchToggle) searchToggle.setAttribute('aria-expanded', 'true');
      var input = searchPanel.querySelector('[data-mobile-search-input]');
      if (input) input.focus();
    }

    function closeSearchPanel() {
      if (!searchPanel) return;
      searchPanel.classList.remove('is-open');
      searchPanel.setAttribute('aria-hidden', 'true');
      if (overlay) overlay.classList.remove('is-visible');
      if (searchToggle) searchToggle.setAttribute('aria-expanded', 'false');
    }

    if (searchToggle && searchPanel) {
      searchToggle.addEventListener('click', function () {
        if (searchPanel.classList.contains('is-open')) {
          closeSearchPanel();
        } else {
          openSearchPanel();
        }
      });
    }

    // Drawer sub-panels (nav items that have a mega menu)
    var panelOpeners = header.querySelectorAll('[data-drawer-panel-open]');
    for (var po = 0; po < panelOpeners.length; po++) {
      panelOpeners[po].addEventListener('click', function (e) {
        e.preventDefault();
        var id = this.getAttribute('data-drawer-panel-open');
        var panel = document.getElementById(id);
        if (panel) {
          panel.classList.add('is-open');
          panel.setAttribute('aria-hidden', 'false');
          panel.scrollTop = 0;
        }
        // Lock the drawer's own scroll so only the panel scrolls (and the
        // page behind can't be dragged while the panel is open).
        if (drawer) drawer.classList.add('oddit-header__drawer--panel-open');
        this.setAttribute('aria-expanded', 'true');
      });
    }

    var panelClosers = header.querySelectorAll('[data-drawer-panel-close]');
    for (var pc = 0; pc < panelClosers.length; pc++) {
      panelClosers[pc].addEventListener('click', function () {
        var panel = this.closest('[data-drawer-panel]');
        if (panel) {
          panel.classList.remove('is-open');
          panel.setAttribute('aria-hidden', 'true');
        }
        if (drawer) drawer.classList.remove('oddit-header__drawer--panel-open');
      });
    }

    function closeAllDrawerPanels() {
      var panels = header.querySelectorAll('[data-drawer-panel]');
      for (var i = 0; i < panels.length; i++) {
        panels[i].classList.remove('is-open');
        panels[i].setAttribute('aria-hidden', 'true');
      }
      var openers = header.querySelectorAll('[data-drawer-panel-open]');
      for (var j = 0; j < openers.length; j++) {
        openers[j].setAttribute('aria-expanded', 'false');
      }
      if (drawer) drawer.classList.remove('oddit-header__drawer--panel-open');
    }

    // Keep the drawer / mega-menu overlay anchored below the header on resize
    window.addEventListener('resize', function () {
      if (drawer && drawer.classList.contains('is-open')) {
        positionDrawerBelowHeader();
      }
      if (searchPanel && searchPanel.classList.contains('is-open')) {
        positionSearchPanelBelowHeader();
      }
      for (var i = 0; i < megaMenus.length; i++) {
        if (megaMenus[i].classList.contains('is-open')) {
          positionOverlayBelowHeader();
          break;
        }
      }
    });

    // Overlay click closes all
    if (overlay) {
      overlay.addEventListener('click', function () {
        closeMegaMenu();
        closeDrawer();
        closeSearchPanel();
      });
    }

    // Cart icon → opens cart drawer
    var cartToggles = header.querySelectorAll('[data-cart-toggle]');
    for (var c = 0; c < cartToggles.length; c++) {
      cartToggles[c].addEventListener('click', function (e) {
        e.preventDefault();
        if (window.OdditCartDrawer && typeof window.OdditCartDrawer.open === 'function') {
          window.OdditCartDrawer.open();
        }
      });
    }

    bindGlobals();
  }

  // Document-level handlers — bound once for the page. They re-query the current
  // header so they keep working across section re-renders.
  function bindGlobals() {
    if (globalsBound) return;
    globalsBound = true;

    // ESC closes any open mega menu / drawer
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape' && e.keyCode !== 27) return;
      var header = document.querySelector('.oddit-header');
      if (!header) return;
      var panels = header.querySelectorAll('[data-mega-menu-panel]');
      for (var i = 0; i < panels.length; i++) {
        panels[i].classList.remove('is-open');
        panels[i].setAttribute('aria-hidden', 'true');
      }
      var triggers = header.querySelectorAll('[data-mega-menu-trigger]');
      for (var j = 0; j < triggers.length; j++) {
        triggers[j].setAttribute('aria-expanded', 'false');
      }
      var drawer = header.querySelector('[data-mobile-drawer]');
      if (drawer) {
        drawer.classList.remove('is-open');
        drawer.setAttribute('aria-hidden', 'true');
      }
      var drawerPanels = header.querySelectorAll('[data-drawer-panel]');
      for (var p = 0; p < drawerPanels.length; p++) {
        drawerPanels[p].classList.remove('is-open');
        drawerPanels[p].setAttribute('aria-hidden', 'true');
      }
      var menuToggle = header.querySelector('[data-mobile-menu-toggle]');
      if (menuToggle) menuToggle.setAttribute('aria-expanded', 'false');
      var searchPanel = header.querySelector('[data-mobile-search-panel]');
      if (searchPanel) {
        searchPanel.classList.remove('is-open');
        searchPanel.setAttribute('aria-hidden', 'true');
      }
      var searchToggle = header.querySelector('[data-mobile-search-toggle]');
      if (searchToggle) searchToggle.setAttribute('aria-expanded', 'false');
      var overlay = header.querySelector('[data-header-overlay]');
      if (overlay) {
        overlay.classList.remove('is-visible');
        overlay.style.top = '';
      }
      document.body.classList.remove('oddit-header-drawer-open');
    });

    // Search clear button — empties the field and refocuses it.
    document.addEventListener('click', function (e) {
      var clearBtn = e.target.closest && e.target.closest('[data-search-clear]');
      if (!clearBtn) return;
      var form = clearBtn.closest('form[role="search"]');
      var input = form && form.querySelector('.oddit-header__search-input');
      if (input) {
        input.value = '';
        input.focus();
      }
    });

    // Live cart count update
    document.addEventListener('cart:updated', function (e) {
      var cart = e.detail && e.detail.cart;
      if (!cart) return;
      var badges = document.querySelectorAll('.oddit-header__cart-count[data-cart-count]');
      for (var i = 0; i < badges.length; i++) {
        badges[i].textContent = cart.item_count;
        badges[i].style.display = cart.item_count > 0 ? '' : 'none';
      }
    });
  }

  setupHeader();

  // Re-initialise when the section is re-rendered (theme dev hot-reload / editor).
  // The __odditHeaderInit flag keeps this from double-binding an unchanged header.
  document.addEventListener('shopify:section:load', setupHeader);
})();
